// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t4HY","jobCards":"styles_jobCards__1W2UZ","viewJobsButton":"styles_viewJobsButton__26YDk","noJobsMessage":"styles_noJobsMessage__3SlTo"};